import {t, Trans} from '@lingui/macro';
import React, {FC, useState} from 'react';

import {AsyncHandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {PopoverProps} from '../../../../../libs/shared/ui/src/components/popovers/popoverTypes';
import {useLocalize} from '../../../../../srcCommon/internationalization/internationalizationContext';
import {AnswerModel} from '../../../../models/api/answerModel';
import {MarkdownEditorBox} from '../../../common/boxedInputs/markdownEditorBox';
import {AnswerDialogBase, AnswerDialogValues} from './answerDialogBase';

/*
 * Props.
 */

export interface MarkdownAnswerDialogProps extends PopoverProps {
  initialText: string;
  namespace: string;
  onCreateClick: AsyncHandlerOf<AnswerDialogValues, AnswerModel>;
}

/*
 * Component.
 */

export const MarkdownAnswerDialog: FC<MarkdownAnswerDialogProps> = (props) => {
  const {initialText, onCreateClick, ...otherProps} = props;
  const [text, setText] = useState(initialText);
  const [hasBodyChanged, setHasBodyChanged] = useState(false);
  const localize = useLocalize();

  const onChange = (value: string) => {
    if (!hasBodyChanged) {
      setHasBodyChanged(true);
    }

    setText(value);
  };

  return (
    <AnswerDialogBase
      {...otherProps}
      onCreateClick={(values) => onCreateClick({...values, body: text})}
      hasValidBodyValue={text.trim().length > 0}
      hasBodyChanged={hasBodyChanged}
    >
      {(bodyProps) => (
        <MarkdownEditorBox
          {...bodyProps}
          value={text}
          onChange={onChange}
          label={<Trans id="answer-create-field-template">Template</Trans>}
          placeholder={localize(t('answer-create-field-template-placeholder')`Type something you send often`)}
        />
      )}
    </AnswerDialogBase>
  );
};
